module.exports = __webpack_public_path__ + "img/switch.312198c6.svg";